var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"generic-list scroll-container"},[_c('CategoryTitle',{attrs:{"category":_vm.category}}),_c('RefundTable'),_c('v-spacer',{staticClass:"spacer-scroll"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }